
import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-8 text-black" style={{ fontFamily: 'Playfair Display, serif' }}>
              {t('whoWeAre')}
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              {t('aboutDescription1')}
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              {t('aboutDescription2')}
            </p>
            <div className="grid grid-cols-2 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-black mb-2">500+</div>
                <div className="text-gray-600">{t('partnerBrands')}</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-black mb-2">5000+</div>
                <div className="text-gray-600">{t('retailPartners')}</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20Hong%20Kong%20business%20district%20skyline%20with%20modern%20skyscrapers%2C%20international%20trade%20hub%20atmosphere%2C%20clean%20corporate%20environment%2C%20sophisticated%20urban%20landscape%2C%20financial%20center%20architecture%2C%20premium%20business%20location%2C%20bright%20daylight%2C%20clear%20visibility&width=600&height=800&seq=about-image&orientation=portrait"
              alt="Hong Kong Business Hub - XINRUNMODA Location"
              className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
